import React, { useRef, useState, useEffect } from "react";
import { Tabs } from "antd";
import { useSearchParams } from "react-router-dom";
import "./style.scss";
import Heading from "../../../components/Heading";
import sorting from "../../../assests/images/SVG/sort-white.svg";
import McnShipmentList from "../../../components/McnShipmentList";
import { MCN_TITLES } from "../../../constants/mcnConstants";

export const ShipmentStatus = {
  MANIFESTED: 2,
  INSCANNED: 3,
  BAGGED: 21,
  IN_BAG_OUTSCAN: 41,
  HUB_OUTSCAN: 5,
  HUB_INSCANNED: 6,
  INSCANNED_AT_TRANSIT: 20,
  IN_BAG_OUTSCAN_TO_3PL: 51,
  OUT_FOR_DELIVERY: 11,
  IN_BAG_INSCAN: 40,
  OUTSCAN_TO_3PL: 53,//Outscan_TO_3PL
  DELIVERED: 12, // Added missing DELIVERED status
  ATTEMPTED: 44,
  RTO_OUT_FOR_DELIVERY: 45,
  RETURN_INITIATED: 15,
  RETURN_REVOKED: 39,
  RTO_DELIVERED: 17,
  undelivered: 55
};
// Tab configurations based on requirements
const tabConfigs = [
  {
    key: "1",
    label: MCN_TITLES.EXPECTING,
    currentOperationCode: [ShipmentStatus.MANIFESTED, ShipmentStatus.RETURN_INITIATED]
  },
  {
    key: "2",
    label: MCN_TITLES.WAITING_FOR_OUTSCAN,
    currentOperationCode: [ShipmentStatus.INSCANNED, ShipmentStatus.BAGGED, ShipmentStatus.INSCANNED_AT_TRANSIT]
  },
  // {
  //   key: "3",
  //   label: MCN_TITLES.SENT_FOR_HUB,
  //   currentOperationCode: [ShipmentStatus.HUB_OUTSCAN, ShipmentStatus.IN_BAG_OUTSCAN, ShipmentStatus.INSCANNED_AT_TRANSIT]
  // },
  {
    key: "3",
    label: MCN_TITLES.DELIVERY_PENDING,
    currentOperationCode: [ShipmentStatus.INSCANNED_AT_TRANSIT, ShipmentStatus.HUB_OUTSCAN, ShipmentStatus.IN_BAG_OUTSCAN, ShipmentStatus.HUB_INSCANNED, ShipmentStatus.OUTSCAN_TO_3PL, ShipmentStatus.OUT_FOR_DELIVERY, ShipmentStatus.IN_BAG_INSCAN
      , ShipmentStatus.ATTEMPTED, ShipmentStatus.RTO_OUT_FOR_DELIVERY, ShipmentStatus.RETURN_INITIATED, ShipmentStatus.RETURN_REVOKED, ShipmentStatus.undelivered
    ]
  },
  {
    key: "4",
    label: MCN_TITLES.DELIVERED,
    currentOperationCode: [ShipmentStatus.DELIVERED, ShipmentStatus.RTO_DELIVERED], // No filter - show all
  },
  // {
  //   key: "5",
  //   label: MCN_TITLES.FAILED_MCN,
  //   currentOperationCode: [],
  // }
  // {
  //   key: "5",
  //   label: MCN_TITLES.RECEIVED_DESTINATION_MCN,
  //   currentOperationCode: [ShipmentStatus.HUB_INSCANNED],
  //   checkDestinationHubMatch: true,
  // }
];

const Index = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  // Get last selected tab from URL or default to "1"
  const getLastSelectedTab = () => {
    const tabParam = searchParams.get("tab");
    return tabParam && tabConfigs.find(tab => tab.key === tabParam) ? tabParam : "1";
  };

  const [activeTab, setActiveTab] = useState(getLastSelectedTab);
  const mcnListRefs = useRef({});

  // Handle tab change and trigger API call
  const handleTabChange = (activeKey) => {
    setActiveTab(activeKey);

    // Update URL with selected tab
    setSearchParams({ tab: activeKey });

    // Call API for the newly selected tab
    if (mcnListRefs.current[activeKey]) {
      mcnListRefs.current[activeKey].fetchData();
    }
  };

  // Set ref for each McnShipmentList component
  // Set ref for each McnShipmentList component
  // const setMcnListRef = (key, ref) => {
  //   if (ref) {
  //     mcnListRefs.current[key] = ref;
  //   }
  // };

  // Call API for the last selected tab on component mount
  useEffect(() => {
    // Small delay to ensure refs are set
    const timer = setTimeout(() => {
      if (mcnListRefs.current[activeTab]) {
        mcnListRefs.current[activeTab].fetchData();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [activeTab]);

  return (
    <div className="p2 consolidated-tab-cntr">
      <Heading
        title={"MCN Outbound"}
        imgSrc={sorting}
        navigateTo={"/mcn"}
      />

      <Tabs
        defaultActiveKey={activeTab}
        activeKey={activeTab}
        onChange={handleTabChange}
        items={tabConfigs.map(config => ({
          key: config.key,
          label: (
            <div className="tab-label">
              <div className="tab-title">{config.label}</div>
            </div>
          ),
          children: (
            <McnShipmentList
              // ref={(ref) => setMcnListRef(config.key, ref)}
              title={config.label}
              bookingStatuses={config.statuses}
              currentOperationCode={config.currentOperationCode}
              checkDestinationHubMatch={config.checkDestinationHubMatch}
              checkDestinationHub={config.checkDestinationHub}
              autoFetch={false}
            />
          )
        }))}
        className="mcn-tabs"
      />
    </div>
  );
};

export default Index;
